import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-cream text-charcoal" data-id="element-182" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-183" data-mp="3b1cjj9hq2yim">
        <h2 id="testimonios" className="font-anton text-2xl uppercase leading-tight sm:text-3xl" data-id="element-184" data-mp="36ypokzpr8xh7">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-charcoal/80" data-id="element-185" data-mp="3229024en8h3l">
          De no saber por dónde comenzar a comprender cómo se diseña y fabrica
          un mueble de melamina.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-186" data-mp="v9g9bl2obyo3">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border-2 border-wood/15 bg-white p-2.5 text-left" data-id="element-187" data-mp="qac1axrhk6zc" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-188" data-mp="m5b5ns9ag0jx">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-cta text-cta" data-id="element-189" data-mp="79bqxyrob25t" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug text-charcoal/90 sm:text-sm" data-id="element-190" data-mp="zwy3hwivph4t">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-191" data-mp="q6wg76yco2qy">
                <p className="font-display text-xs font-extrabold uppercase text-wood" data-id="element-192" data-mp="q63c6dqrzrci">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-charcoal/70" data-id="element-193" data-mp="1ivadfkhm6v1g">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-cta bg-charcoal p-3" data-id="element-194" data-mp="1nnv44d584s0r">
            <CtaButton href={OFFER_ANCHOR} data-id="element-195" data-mp="1ohaw6jv38tr9">🚀 Sí, quiero comenzar ahora</CtaButton>
            <p className="mt-2 text-xs font-medium text-white/80" data-id="element-196" data-mp="1ojf8nq71z135">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}